import React, { useRef, useState } from 'react';
import _ from 'lodash';
import { messageUtility } from '../../utilities/messageUtility';
import { STATUS_CODE } from '../../utilities/constants';
import LwGroupApi from '../../services/LwGroupApi';
import LwTalkroomApi from '../../services/LwTalkroomApi';
import { closeType } from './errorInfomation';
import { LwUsers } from '../../services/lwUser/Base';
import { AssignUsers } from '../../services/lwUser/Group';
import { SearchCondition } from '../../services/lwUser/SearchCondition';
import { HttpError } from '../../services/lwUser/Error';

/**
 * グループ登録用ヘッダー表示部分
 * @param {number} fieldId 現場名
 * @param {GroupName} groupName グループ名
 * @param {number[]} registerlwUserIds 登録するユーザーIDの配列
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 * @param {function} clickSubmit 送信ボタンを押下した時に動作する関数
 * @param {function} displayErrorInfomation エラー画面を表示する関数
 **/
function RenderGroupRegisterFooter({
  fieldId,
  groupName,
  registerlwUserIds,
  clickBack,
  clickSubmit,
  displayErrorInfomation,
}) {
  const isSubmit = () => {
    return !(groupName.isInvalid() || _.isEmpty(registerlwUserIds));
  };

  const sendData = async () => {
    const { data, result, status } = await LwGroupApi.create(fieldId, {
      name: groupName.value,
      user_ids: registerlwUserIds,
    });
    return { data, result, status };
  };

  return (
    <RenderSubmitFooter
      submitButtonLabel={messageUtility.getMessage('I-000-080')}
      isSubmit={isSubmit}
      sendData={sendData}
      clickBack={clickBack}
      clickSubmit={clickSubmit}
      displayErrorInfomation={displayErrorInfomation}
    />
  );
}

/**
 * グループ更新用ヘッダー表示部分
 * @param {number} fieldId 現場名
 * @param {number} lwGroupId LINE WORKSのグループID
 * @param {GroupName} groupName グループ名
 * @param {number[]} rightMovedUserIds 右へ移動したユーザーIDの配列
 * @param {number[]} rightMovedUserIds 右へ移動したユーザーIDの配列
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 * @param {function} clickSubmit 送信ボタンを押下した時に動作する関数
 * @param {function} displayErrorInfomation エラー画面を表示する関数
 **/
function RenderGroupEditFooter({
  fieldId,
  lwGroupId,
  groupName,
  rightMovedUserIds,
  leftMovedUserIds,
  clickBack,
  clickSubmit,
  displayErrorInfomation,
}) {
  // NOTE：将来的には、初回表示時ユーザーを親コンポーネントに保存しておくように修正予定
  const [firstUser, setFirstUsers] = useState(new LwUsers());
  const getAssignUsers = async () => {
    try {
      const assignUsers = await AssignUsers.createByApiData(
        fieldId,
        lwGroupId,
        new SearchCondition()
      );
      setFirstUsers(assignUsers);
    } catch (e) {
      if (e instanceof HttpError) {
        displayErrorInfomation(_.get(e, 'message', ''), closeType.modal_close);
      } else {
        throw e;
      }
    }
  };
  const firstAction = useRef(true);
  if (firstAction.current) {
    firstAction.current = false;
    getAssignUsers();
  }
  const updatelwUserIds = _.uniq(
    _.reject(_.concat(firstUser.ids, rightMovedUserIds), function(userId) {
      return leftMovedUserIds.includes(userId);
    })
  );

  const isSubmit = () => {
    return !(groupName.isInvalid() || _.isEmpty(updatelwUserIds));
  };

  const sendData = async () => {
    const { data, result, status } = await LwGroupApi.update(
      fieldId,
      lwGroupId,
      {
        name: groupName.value,
        user_ids: updatelwUserIds,
      }
    );
    return { data, result, status };
  };

  return (
    <RenderSubmitFooter
      submitButtonLabel={messageUtility.getMessage('I-000-088')}
      isSubmit={isSubmit}
      sendData={sendData}
      clickBack={clickBack}
      clickSubmit={clickSubmit}
      displayErrorInfomation={displayErrorInfomation}
    />
  );
}

/**
 * トークルーム登録用ヘッダー表示部分
 * @param {number} fieldId 現場名
 * @param {TalkroomName} talkroomName トークルーム名
 * @param {number[]} registerlwUserIds 登録するユーザーIDの配列
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 * @param {function} clickSubmit 送信ボタンを押下した時に動作する関数
 * @param {function} displayErrorInfomation エラー画面を表示する関数
 **/
function RenderTalkroomRegisterFooter({
  fieldId,
  talkroomName,
  registerlwUserIds,
  clickBack,
  clickSubmit,
  displayErrorInfomation,
}) {
  const isSubmit = () => {
    return !(talkroomName.isInvalid() || _.isEmpty(registerlwUserIds));
  };

  const sendData = async () => {
    const { data, result, status } = await LwTalkroomApi.create(fieldId, {
      name: talkroomName.value,
      user_ids: registerlwUserIds,
    });
    return { data, result, status };
  };

  return (
    <RenderSubmitFooter
      submitButtonLabel={messageUtility.getMessage('I-000-080')}
      isSubmit={isSubmit}
      sendData={sendData}
      clickBack={clickBack}
      clickSubmit={clickSubmit}
      displayErrorInfomation={displayErrorInfomation}
    />
  );
}

/**
 * トークルーム閲覧用ヘッダー表示部分
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 **/
function RenderTalkroomShowFooter({ clickBack }) {
  return (
    <div className='dialog__footer'>
      <button className='btn-fixedsize--sub' onClick={clickBack}>
        {messageUtility.getMessage('I-000-008')}
      </button>
    </div>
  );
}

function RenderSubmitFooter({
  submitButtonLabel,
  isSubmit,
  sendData,
  clickBack,
  clickSubmit,
  displayErrorInfomation,
}) {
  const classBtnSubmit = isSubmit()
    ? 'btn-fixedsize--effective'
    : 'btn-fixedsize--effective btn--disabled';

  const handleOnsubmit = useHandleOnsubmit(
    isSubmit,
    clickSubmit,
    sendData,
    displayErrorInfomation
  );

  return (
    <div className='dialog__footer'>
      <button className='btn-fixedsize--sub' onClick={clickBack}>
        {messageUtility.getMessage('I-000-008')}
      </button>
      <button
        className={classBtnSubmit}
        disabled={!isSubmit()}
        onClick={handleOnsubmit}
      >
        {submitButtonLabel}
      </button>
    </div>
  );
}

function useHandleOnsubmit(
  isSubmit,
  clickSubmit,
  sendData,
  displayErrorInfomation
) {
  const isSending = useRef(false);

  const handleOnsubmit = async () => {
    if (!isSubmit | isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const { data, result, status } = await sendData();
      if (result) {
        return clickSubmit();
      }
      if (status === STATUS_CODE.badRequest) {
        displayErrorInfomation(_.get(data, 'message'), closeType.error_close);
      }
    } finally {
      isSending.current = false;
    }
  };
  return handleOnsubmit;
}

export {
  RenderGroupRegisterFooter,
  RenderGroupEditFooter,
  RenderTalkroomRegisterFooter,
  RenderTalkroomShowFooter,
};



// WEBPACK FOOTER //
// ./src/components/lwUser/footer.jsx